import PopoverMenu from '@/components/PopoverMenu'
import ViverseButton from '@/components/ViverseButton'
import IconDiamond from '@/components/assets/icon_diamond.svg'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { useConfigsContext } from '@/context/ConfigsContext'
import { Link } from '@/i18n/navigation'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

export default function PremiumPopoverButton({ label }: { label: string }) {
  const isCreator = false
  const t = useTranslations()
  const { appConfig } = useConfigsContext()
  const VIVERSE_MARKET_LINK = appConfig?.links?.viverse_market
  const [menuOpen, setMenuOpen] = useState(false)
  const handleClickIcon = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <Popover open={menuOpen} onOpenChange={setMenuOpen}>
      <PopoverTrigger asChild onClick={handleClickIcon}>
        <ViverseButton
          className={cn(
            'group h-8 min-w-[156px] gap-1 px-4 text-sm md:h-9 md:gap-2 md:px-5 md:text-base',
            {
              hidden: isCreator,
            },
          )}
          variant="extraOutline"
        >
          <IconDiamond className="size-5 fill-[#FF82FB] group-hover:fill-[#FF5FFA] group-active:fill-[#9D2199] md:size-6" />
          <span className="bg-gradient-title-3 group-hover:bg-gradient-btn-hover group-active:bg-gradient-btn-active bg-clip-text text-transparent">
            {label}
          </span>
          <ChevronDown className="size-5 stroke-[#53FFF6] group-hover:stroke-[#1FFFF3] group-active:stroke-[#008D86] md:size-6" />
        </ViverseButton>
      </PopoverTrigger>
      <PopoverContent align="end" className="mt-2 border-none bg-transparent p-0">
        <PopoverMenu className="bg-vive-primary-70/50 rounded-[5px] backdrop-blur-xl">
          <PopoverMenu.Group>
            <Link href={`${VIVERSE_MARKET_LINK}/activity`}>
              <PopoverMenu.Item className="hover:text-vive-brand-50 hover:bg-transparent">
                <div className="body-1 text-inherit">
                  {t('profile-page.premium-popover.purchase-detail')}
                </div>
              </PopoverMenu.Item>
            </Link>
            <Link href={`${VIVERSE_MARKET_LINK}/subscriptions`}>
              <PopoverMenu.Item className="hover:text-vive-brand-50 hover:bg-transparent">
                <div className="body-1 text-inherit">
                  {t('profile-page.premium-popover.manage-subscription')}
                </div>
              </PopoverMenu.Item>
            </Link>
          </PopoverMenu.Group>
        </PopoverMenu>
      </PopoverContent>
    </Popover>
  )
}
